module.exports = __webpack_public_path__ + "static/WindingWorlds5-7c5770b904fe179f1db8c975e90cd559.webp";